import { useState } from 'react';

export const MARKETING_ASSETS = {
  heroPhone: {
    src: `${process.env.PUBLIC_URL}/assets/landing/hero-phone.png`,
    alt: 'TECNIQ mobile app hero screenshot',
  },
  heroWorkout: {
    src: `${process.env.PUBLIC_URL}/assets/landing/hero-workout-screen.png`,
    alt: 'TECNIQ workout logging screen',
  },
  heroAnalytics: {
    src: `${process.env.PUBLIC_URL}/assets/landing/analytics-overview-screen.png`,
    alt: 'TECNIQ analytics overview screen',
  },
  trendAnalysis: {
    src: `${process.env.PUBLIC_URL}/assets/landing/analytics-overview-screen.png`,
    alt: 'TECNIQ analytics overview screen',
  },
  systemDetail: {
    src: `${process.env.PUBLIC_URL}/assets/landing/body-journal-screen.png`,
    alt: 'TECNIQ body journal screen',
  },
  analyticsOverview: {
    src: `${process.env.PUBLIC_URL}/assets/landing/analytics-overview-screen.png`,
    alt: 'TECNIQ analytics overview screen',
  },
  analyticsDetail: {
    src: `${process.env.PUBLIC_URL}/assets/landing/analytics-detail-screen.png`,
    alt: 'TECNIQ analytics detail screen',
  },
  bodyJournal: {
    src: `${process.env.PUBLIC_URL}/assets/landing/body-journal-screen.png`,
    alt: 'TECNIQ body journal screen',
  },
  videoPreviewCard: {
    src: `${process.env.PUBLIC_URL}/assets/landing/video-preview-card.png`,
    alt: 'TECNIQ progress video preview',
  },
  trackCardReference: {
    src: `${process.env.PUBLIC_URL}/assets/landing/track-card-reference.png`,
    alt: 'TECNIQ tracking card reference',
  },
  measurementCardReference: {
    src: `${process.env.PUBLIC_URL}/assets/landing/measurement-card-reference.png`,
    alt: 'TECNIQ measurement card reference',
  },
};

export default function ProductMockup({
  asset,
  className = '',
  alt,
  fallback = null,
  loading = 'lazy',
  objectFit = 'cover',
  objectPosition = 'center center',
  style = {},
}) {
  const [hasError, setHasError] = useState(false);
  const assetConfig = MARKETING_ASSETS[asset];
  const resolvedAlt = alt || assetConfig?.alt || 'TECNIQ product artwork';

  if (!assetConfig || hasError) {
    if (!fallback) {
      return null;
    }

    return (
      <div
        className={`marketing-asset marketing-asset--fallback ${className}`.trim()}
        role="img"
        aria-label={resolvedAlt}
      >
        {fallback}
      </div>
    );
  }

  return (
    <img
      className={`marketing-asset ${className}`.trim()}
      src={assetConfig.src}
      alt={resolvedAlt}
      loading={loading}
      onError={() => setHasError(true)}
      style={{ objectFit, objectPosition, ...style }}
    />
  );
}
